import React from 'react';
import {
  Stack, Typography,
} from '@mui/material';
import { BackButton } from '@marageti/z4-lib';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import TravelerForm from './traveler-form';
import TravelerCreated from './traveler-created';

type TravelerCreateAccountFormViewProps = {
  handleSubmit: (data: any) => void
  submissionError: ApiError | undefined
  successfullyCreatedTraveler: Traveler | undefined
  onCancel?: () => void
};

const TravelerCreateAccountFormView = ({
  handleSubmit,
  submissionError,
  successfullyCreatedTraveler,
  onCancel = undefined,
}: TravelerCreateAccountFormViewProps) => {
  if (successfullyCreatedTraveler) {
    return (
      <TravelerCreated traveler={successfullyCreatedTraveler} />
    );
  }

  return (
    <>
      <BackButton
        defaultPath="/traveler"
        edge="start"
        sx={{
          mb: 2,
        }}
      />
      <Stack
        spacing={2}
        width="100%"
      >
        <Stack spacing={1}>
          <Typography variant="h2">New Traveler Account</Typography>
        </Stack>
        <TravelerForm
          onSubmit={handleSubmit}
          submissionError={submissionError}
          onCancel={onCancel}
        />
      </Stack>
    </>
  );
};

export default TravelerCreateAccountFormView;
